import { createSelector } from "reselect";

const selectUser = (state) => state.user;

export const selectCurrentUser = createSelector(
  [selectUser],
  (user) => user.currentUser
);

export const selectUsers = createSelector([selectUser], (user) => user.items);

export const selectIsUsersLoading = createSelector([selectUser], (user) => {
  return user.loading || !!!user.items;
});

export const selectUserError = createSelector(
  [selectUser],
  (user) => user.error
);
